import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://kwbotrous.com';
const SITE_NAME = 'Katherine William-Botrous';
const DEFAULT_TITLE = `${SITE_NAME} | Sales Leadership & Organizational Excellence`;
const DEFAULT_DESCRIPTION = 'Katherine William-Botrous is a Vice President of Sales with senior leadership across client success, operations, and customer service — P&L ownership, high-performance teams, and contact-center excellence.';
const HEADSHOT = `${SITE_URL}/assets/katherine-headshot.webp`;

const Seo = ({ title, description, path = '/', image = HEADSHOT, schema, pageType = 'website', noIndex = false }) => {
  const pageTitle = title || DEFAULT_TITLE;
  const pageDescription = description || DEFAULT_DESCRIPTION;
  const fullUrl = `${SITE_URL}${path}`;
  const personSchema = schema || {
    '@context': 'https://schema.org',
    '@type': 'Person',
    '@id': `${SITE_URL}/#katherine-william-botrous`,
    name: SITE_NAME,
    url: SITE_URL,
    image: HEADSHOT,
    jobTitle: 'Vice President of Sales',
    worksFor: {
      '@type': 'Organization',
      name: 'ReminderMedia',
      sameAs: ['https://remindermedia.com'],
    },
    sameAs: ['https://www.linkedin.com/in/kathy-william-botrous'],
    knowsAbout: ['Sales leadership', 'Client success', 'Operations', 'Customer service', 'Tech support', 'P&L ownership', 'Revenue growth', 'Contact-center operations', 'High-performance teams', 'Organizational excellence'],
    description: pageDescription,
  };

  return (
    <Helmet>
      <html lang="en" />
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="author" content={SITE_NAME} />
      <meta name="robots" content={noIndex ? 'noindex, nofollow' : 'index, follow'} />
      <link rel="canonical" href={fullUrl} />
      <meta property="og:type" content={pageType} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={`${SITE_URL}${image.startsWith('/') ? image : `/${image}`}`} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={`${SITE_URL}${image.startsWith('/') ? image : `/${image}`}`} />
      <script type="application/ld+json">{JSON.stringify(personSchema)}</script>
    </Helmet>
  );
};

export default Seo;
